// Angular
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable, OnDestroy, OnInit } from '@angular/core';

// Libraries
import { Observable } from 'rxjs';

// Models
import { AppCleanup } from '../models';

export interface CanComponentDeactivate {
	canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard extends AppCleanup implements OnInit, OnDestroy {
	constructor() {
		super();
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	canDeactivate(component: CanComponentDeactivate, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		return component.canDeactivate();
	}
}
